module.exports = __webpack_public_path__ + "assets/2b49abea007ee0a4c1d7fe53eb293d58.png";